import AppStoreDark from '../../src/legacy/AppStoreDark';
export default AppStoreDark;
